export default __webpack_public_path__ + "static/media/livingroom.d90534a3.svg";